var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({attrs:{"to":_vm.toPayload,"target":_vm.newTab ? '_blank' : false},nativeOn:{"click":function($event){return $event.stopImmediatePropagation()}}},'router-link',{ exact: _vm.exact, tag: _vm.tag },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }